import { Link } from 'react-router-dom'
import { ABOUT_CONTENT, IMAGES } from '../data/content'

function AboutSection() {
  return (
    <section id="about" className="relative py-20 px-4 bg-white scroll-mt-20 overflow-hidden">
      <div className="max-w-[1500px] mx-auto grid lg:grid-cols-2 gap-16 items-center px-6">
        {/* Photos with Blue Blobs */}
        <div className="relative h-[500px] hidden lg:block">
          {/* Large blue blob - top right */}
          <div className="absolute top-0 right-0 w-[300px] h-[280px] bg-brand-blue rounded-[100px] opacity-80"></div>

          {/* Medium blue blob - bottom left */}
          <div className="absolute bottom-0 left-0 w-[280px] h-[250px] bg-brand-blue-light rounded-[80px] opacity-60"></div>

          {/* Photo 1 - top left */}
          <div
            className="absolute top-8 left-8 bg-white p-2 rounded-xl shadow-xl z-10 transform -rotate-3"
            style={{ width: '200px' }}
          >
            <div className="aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
              <img
                src={IMAGES.graphic1 || '/images/placeholder.jpg'}
                alt="CS Foreach activity"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Photo 2 - top right, overlapping blob */}
          <div
            className="absolute top-4 right-16 bg-white p-2 rounded-xl shadow-xl z-20 transform rotate-2"
            style={{ width: '220px' }}
          >
            <div className="aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
              <img
                src={IMAGES.graphic2 || '/images/placeholder.jpg'}
                alt="CS Foreach team"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Photo 3 - bottom center, overlapping blob */}
          <div
            className="absolute bottom-8 left-24 bg-white p-2 rounded-xl shadow-xl z-30 transform rotate-1"
            style={{ width: '240px' }}
          >
            <div className="aspect-[4/3] bg-gray-200 rounded-lg overflow-hidden">
              <img
                src={IMAGES.graphic3 || '/images/placeholder.jpg'}
                alt="Students coding"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>

        {/* Mobile: Single image */}
        <div className="lg:hidden flex justify-center">
          <div className="relative">
            <img
              src={IMAGES.about}
              alt="About CS Foreach"
              className="max-w-sm w-full rounded-2xl shadow-xl"
            />
          </div>
        </div>

        {/* Content */}
        <div className="text-center lg:text-left">
          <h3 className="text-3xl md:text-4xl font-heading font-bold text-brand-blue mb-2">
            {ABOUT_CONTENT.title}
          </h3>
          <div className="w-32 h-1 bg-brand-blue mb-6 mx-auto lg:mx-0"></div>

          <p className="text-lg md:text-xl text-gray-700 leading-relaxed mb-8">
            {ABOUT_CONTENT.description}
          </p>
          <Link
            to={ABOUT_CONTENT.buttonHref}
            className="btn btn-primary-solid rounded-lg"
          >
            {ABOUT_CONTENT.buttonLabel}
          </Link>
        </div>
      </div>
    </section>
  )
}

export default AboutSection
